var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecurityImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 259.559,
    height: 171.748,
    viewBox: "0 0 259.559 171.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22460",
    "data-name": "Group 22460",
    transform: "translate(21401 23549.449)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11921",
    "data-name": "Path 11921",
    d: "M64.339,225H242.99c8.639,0,15.974,7.082,15.71,15.716l-3.262,107.636a15.948,15.948,0,0,1-15.709,15.715H67.6a15.978,15.978,0,0,1-15.716-15.715L48.624,240.72C48.365,232.082,55.695,225,64.339,225m0,8.585H242.99a7.082,7.082,0,0,1,7.131,7.131l-3.262,107.636a7.324,7.324,0,0,1-7.131,7.131H67.6a7.278,7.278,0,0,1-7.131-7.131L57.209,240.72a7.078,7.078,0,0,1,7.131-7.131",
    transform: "translate(-21441.094 -23774.453)",
    fill: "#cbd5eb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11922",
    "data-name": "Path 11922",
    d: "M290.588,281.1a7.156,7.156,0,0,0-5.7-6.987l-.168-.03v-.006l-.349-.048-.18-.025-.174-.018-.186-.012-.18-.006H104.632l-.18.006-.18.012-.18.018-.18.025-.174.024a7.154,7.154,0,0,0-6.05,7.047l3.262,107.636a7.274,7.274,0,0,0,7.131,7.131H280.207a7.324,7.324,0,0,0,7.131-7.131Z",
    transform: "translate(-21481.559 -23814.832)",
    fill: "#e9eef7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11923",
    "data-name": "Path 11923",
    d: "M321.857,321.97h-176l3.184,105.065H318.673Z",
    transform: "translate(-21521.289 -23854.418)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11924",
    "data-name": "Path 11924",
    d: "M0,1018.176H227.143v7a7.021,7.021,0,0,1-7,7H7a7.025,7.025,0,0,1-7-7Z",
    transform: "translate(-21401 -24428.559)",
    fill: "#8ca3ca",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11926",
    "data-name": "Path 11926",
    d: "M982.843,1154.98c6.163-.1,10.765-.175,12.892-.865,2.295-.751,1.82-2.193.5-4.5-5.807,2.751-4.259-.564-6.974-.144q-2.866,2.37-8.477,3.184c-1.586,1.2-.943,2.277,2.055,2.325",
    transform: "translate(-22209.133 -24536.803)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11927",
    "data-name": "Path 11927",
    d: "M1036.649,629.35h38.064a1.923,1.923,0,0,1,1.724,1.406l6.771,26.577a1.042,1.042,0,0,1-1,1.406h-38.063a1.913,1.913,0,0,1-1.724-1.406l-6.771-26.577a1.046,1.046,0,0,1,1-1.406",
    transform: "translate(-22255.027 -24107.906)",
    fill: "#d2e4fd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11928",
    "data-name": "Path 11928",
    d: "M1210.5,489.207l4.6,18.04a109.37,109.37,0,0,0,19.146-12.946c.192-2.571.42-4.626.7-6.152-.559-1.147-1.172-2.367-1.838-3.671q9.659-.063,11.78-4.283a88.214,88.214,0,0,0-7.227-15.909q-3.244-4.937-12.706-5.808c-.739,8.717-13.715,8.272-10.663.763a25.224,25.224,0,0,0-11.967,7.222,117.9,117.9,0,0,0-5.142,14.952,24.935,24.935,0,0,0,8.681,4.276,19.7,19.7,0,0,1,.288,2.11h2.631a1.9,1.9,0,0,1,1.718,1.406",
    transform: "translate(-22388.277 -23966.992)",
    fill: "#699dee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11929",
    "data-name": "Path 11929",
    d: "M1081.755,645.169l-4.6-18.04a1.9,1.9,0,0,0-1.718-1.406h-38.063c-.751,0-2.085,1-1.862,1.766a1.014,1.014,0,0,1,1.045-1.13h38.063a1.922,1.922,0,0,1,1.724,1.406l6.771,26.577a1.134,1.134,0,0,1-.27,1.135c.631-.414,1.226-1.226,1.087-1.772Z",
    transform: "translate(-22254.932 -24104.914)",
    fill: "#d2e4fd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11930",
    "data-name": "Path 11930",
    d: "M1120.4,787.927h-38.063a1.454,1.454,0,0,1-.421-.06c.763,2.024,2.818,1.724,3.623,1.718h45.128c2.445-.108,2.379-1.875,2.415-3.581h-10.843a2.291,2.291,0,0,1-1.106,1.652,1.056,1.056,0,0,1-.733.27",
    transform: "translate(-22293.225 -24237.094)",
    fill: "#d2e4fd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11932",
    "data-name": "Path 11932",
    d: "M1159.337,698.668a3.03,3.03,0,0,1,2.86,2.541,2.1,2.1,0,0,1-2.078,2.548,3.042,3.042,0,0,1-2.866-2.548,2.1,2.1,0,0,1,2.084-2.541",
    transform: "translate(-22355.324 -24165.07)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11933",
    "data-name": "Path 11933",
    d: "M1324.809,725.143a42.276,42.276,0,0,1-1.64-7.426c-5.124,2.043-10.988,4.013-18.4,7.035l1,3.929q16.8.558,19.038-3.538",
    transform: "translate(-22477.002 -24180.779)",
    fill: "#699dee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11934",
    "data-name": "Path 11934",
    d: "M1300.331,619.752c7.413-3.022,13.277-4.992,18.4-7.035a62.066,62.066,0,0,0,12.394-6.344,50.221,50.221,0,0,0-2.986-15.98q-2.866,2.82-10.747,2.872,2.279,4.442,3.718,7.665c-7.906,6.758-15.529,11.991-21.723,15.1Z",
    transform: "translate(-22472.566 -24075.779)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11935",
    "data-name": "Path 11935",
    d: "M1195.338,593.207c-.571,2.053-1.1,3.958-1.586,5.7h9.57a19.746,19.746,0,0,0-.288-2.11,23.788,23.788,0,0,1-7.7-3.591",
    transform: "translate(-22385.449 -24078.1)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11936",
    "data-name": "Path 11936",
    d: "M1043.7,862.9q8.5-31.737,6.079-44.594a47.831,47.831,0,0,0,9.69.443c-.493-2.288-.991-4.583-1.5-6.908.06-3.155,1.622-5.5,7.173-7.173h-15.776a4.736,4.736,0,0,1-2.523-.373c-5.082,1.5-7.569,3.965-8.417,6.981-.618,8.3,1.058,17.758-.372,51.689a25.46,25.46,0,0,0,5.641-.066",
    transform: "translate(-22257.057 -24252.184)",
    fill: "#1c2a47",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11937",
    "data-name": "Path 11937",
    d: "M1049.617,804.674h-.246a4.736,4.736,0,0,1-2.523-.373c-5.088,1.5-7.569,3.965-8.417,6.981-.618,8.3,1.058,17.758-.372,51.689a24.686,24.686,0,0,0,3.292.114c2.925-11.8,9.882-40.725,2.042-53.19a30.845,30.845,0,0,1,6.224-5.221",
    transform: "translate(-22257.057 -24252.184)",
    fill: "#040227",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11938",
    "data-name": "Path 11938",
    d: "M1283.357,368.435a13.736,13.736,0,0,1-2.158-3.424c.2-.6.421-1.352.637-2.264q5.668-3.966,1.55-5.87a7.574,7.574,0,0,0-2.06,2.956,1.7,1.7,0,0,1-1.49-1.039,52.08,52.08,0,0,0,1.526-6.783c-1.862-2.848-6.218-3.256-11.979-2.487-.271,1.58-.486,3.256-.661,5.021-1.016.967-.883,4.56.054,8.694q-.7,3.523,4.224,3.851a7.458,7.458,0,0,1-.295,2.019v.006c0,.006,0,.012-.012.024-3,7.45,9.847,7.912,10.665-.7",
    transform: "translate(-22446.691 -23876.859)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11939",
    "data-name": "Path 11939",
    d: "M1261.175,317.023c5.761-.769,10.117-.361,11.979,2.487a52.06,52.06,0,0,1-1.526,6.783,1.7,1.7,0,0,0,1.49,1.039,7.577,7.577,0,0,1,2.061-2.956q4.118,1.9-1.55,5.87c-.216.912-.432,1.664-.637,2.264,3.4-.788,6.242-3.917,6.644-5.275,3.966-8.049-.456-11.456-2.823-12.693-1.045-7.979-12.28-.926-17.915-4.771-2.235,3.184.529,7.179,2.277,7.251",
    transform: "translate(-22438.486 -23844.359)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11940",
    "data-name": "Path 11940",
    d: "M1299.752,450.733a32.937,32.937,0,0,1-4.271.1,6.22,6.22,0,0,1-.2,1.664,5.747,5.747,0,0,0,4.476-1.766",
    transform: "translate(-22469.176 -23960.605)",
    fill: "#f08261",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11941",
    "data-name": "Path 11941",
    d: "M1210.99,878.174h34.345a2.3,2.3,0,0,1,0,4.6H1210.99a2.3,2.3,0,0,1,0-4.6",
    transform: "translate(-22397.828 -24313.104)",
    fill: "#ba6939",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11942",
    "data-name": "Path 11942",
    d: "M1247.609,1113.709a8.9,8.9,0,0,0-6.4-2.746h-17.44a8.91,8.91,0,0,0-6.4,2.746,9.477,9.477,0,0,0-2.662,6.6v1.881h-.7v2.331h5.148v-2.331h-.7v-1.881a5.531,5.531,0,0,1,1.568-3.869,5.193,5.193,0,0,1,3.749-1.61h17.44a5.223,5.223,0,0,1,3.756,1.61,5.557,5.557,0,0,1,1.561,3.869v1.881h-.7v2.331h5.143v-2.331h-.7v-1.881a9.477,9.477,0,0,0-2.661-6.6",
    transform: "translate(-22402.15 -24505.078)",
    fill: "#da8847",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3598",
    "data-name": "Rectangle 3598",
    width: 3.749,
    height: 36.213,
    transform: "translate(-21171.537 -23430.326)",
    fill: "#da8847"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11943",
    "data-name": "Path 11943",
    d: "M1193.071,785.289c6.644-2.457,7.545-9.27,4.627-19.573q-3.607,3.038-18.2,2.548l.228.889a.87.87,0,0,1,.018.12h10.843c-.036,1.705.03,3.472-2.415,3.581h-29.353c-5.551,1.676-7.113,4.018-7.173,7.173,3.514,16.178,6.638,31.011,10.9,51.508q2.154,1.243,5.887-.192,3-29.818-1.64-43.362c8.213.03,16.971-1.123,26.283-2.691",
    transform: "translate(-22350.725 -24220.363)",
    fill: "#040227",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11944",
    "data-name": "Path 11944",
    d: "M1255.912,785.289c6.644-2.457,7.545-9.27,4.627-19.573a7.066,7.066,0,0,1-2.032,1.131c2.421,10.586-.21,16.388-8.014,16.94a146.192,146.192,0,0,1-22.648,2.007q3.965,26.475,1.358,46.161a12.442,12.442,0,0,0,2.067-.613q3-29.818-1.64-43.362c8.213.03,16.972-1.123,26.283-2.691",
    transform: "translate(-22413.566 -24220.363)",
    fill: "#233862",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11945",
    "data-name": "Path 11945",
    d: "M1037.663,1138.837a5.8,5.8,0,0,1-.805,1.8c1.779.174,1.094,2.535,5.893.366a7.974,7.974,0,0,1-.342-2.247,25.824,25.824,0,0,1-4.746.084",
    transform: "translate(-22256.064 -24527.996)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11946",
    "data-name": "Path 11946",
    d: "M1188.433,1161.673c3.274-1.394,3.761-3.658,5.563-4.523s2.019-2.421.246-4.109c-1.31,1.075-2.932,2.4-3.789,1.7-.572-.468-2.519-.438-2.909.247-1.694,4.061-4.049,2.775-4.518,4.62-.054,2.463,3.352,2.937,5.407,2.066",
    transform: "translate(-22376.605 -24539.777)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11947",
    "data-name": "Path 11947",
    d: "M1215.046,1141.754a10.641,10.641,0,0,1-.427,3.25,2.793,2.793,0,0,1,1.888.27c.8.649,2.245-.438,3.495-1.46a9.447,9.447,0,0,1-.409-2.253,6.858,6.858,0,0,1-4.547.192",
    transform: "translate(-22402.658 -24530.311)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11948",
    "data-name": "Path 11948",
    d: "M1264.666,566.45a46.609,46.609,0,0,1-2.685-6.362c.51,3.106.48,5.34,1.3,7.888a55.546,55.546,0,0,0-.871,11q1.685-1.3,3.394-2.7c.192-2.571.42-4.626.7-6.152-.559-1.147-1.171-2.367-1.838-3.67m-29.215.625a17.258,17.258,0,0,0,1.971.588q-.369-5.919-.486-9.785-1.109,5.7-1.484,9.2m32.194,26.253a42.274,42.274,0,0,1-1.64-7.426c-.949.379-1.922.751-2.932,1.136a75.349,75.349,0,0,0,1.713,8.411,5.238,5.238,0,0,0,2.859-2.121",
    transform: "translate(-22419.838 -24048.963)",
    fill: "#4a75cb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11949",
    "data-name": "Path 11949",
    d: "M609.754,635.073a8.083,8.083,0,0,1,2.4,15.8v9.768a2.4,2.4,0,0,1-4.806,0v-9.768a8.083,8.083,0,0,1,2.4-15.8",
    transform: "translate(-21897.182 -24112.625)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11950",
    "data-name": "Path 11950",
    d: "M771.057,13.858C757.4,11.3,745.214,6.494,731.069,0c-14.15,6.5-26.334,11.3-39.992,13.861,2.787,41.083,14.971,62.586,39.992,69.094,25.021-6.509,37.2-28.011,39.988-69.094",
    transform: "translate(-22018.488 -23521.215)",
    fill: "#cbd5eb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11951",
    "data-name": "Path 11951",
    d: "M798.3,53.272c-11.7-2.74-22.652-7.1-33.637-12.059-10.986,4.961-21.944,9.318-33.643,12.059,1.645,18.273,6.1,40.865,21.116,52.04a39.362,39.362,0,0,0,12.527,6.123,39.35,39.35,0,0,0,12.527-6.123c15.016-11.176,19.466-33.767,21.111-52.04",
    transform: "translate(-22052.082 -23555.879)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11952",
    "data-name": "Path 11952",
    d: "M976.306,53.272c-11.693-2.74-22.652-7.1-33.637-12.059v70.222a39.35,39.35,0,0,0,12.527-6.123c15.016-11.176,19.466-33.767,21.111-52.04",
    transform: "translate(-22230.086 -23555.879)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11953",
    "data-name": "Path 11953",
    d: "M879.961,121.938A11.849,11.849,0,0,1,882.3,145.4v19.923a2.342,2.342,0,1,1-4.684,0v-.615h-7.151v-3.534h7.151v-2.419h-4.33v-3.535h4.33V145.4a11.849,11.849,0,0,1,2.342-23.464",
    transform: "translate(-22167.379 -23623.773)",
    fill: "#699dee",
    fillRule: "evenodd",
    opacity: 0.85
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityImage);
export default __webpack_public_path__ + "static/media/security-image.30e250ae4eed5b5650453717f21dba40.svg";
export { ForwardRef as ReactComponent };